import { DELETE_LEVEL_UP_REWARD } from "../levelUpReward/types";
import {
  GET_RECHARGE_REWARDS,
  OPEN_RECHARGE_REWARD_DIALOG,
  CLOSE_RECHARGE_REWARD_DIALOG,
  EDIT_RECHARGE_REWARD,
  ADD_RECHARGE_REWARD,
  DELETE_RECHARGE_REWARD
} from "./types";

const initialState = {
  rechargeRewards: [],
  dialog: false,
  dialogData: null,
};

const rechargeRewardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RECHARGE_REWARDS:
      return {
        ...state,
        rechargeRewards: action.payload,
      };
    case OPEN_RECHARGE_REWARD_DIALOG:
      return {
        ...state,
        dialog: true,
        dialogData: action.payload || null,
      };
    case CLOSE_RECHARGE_REWARD_DIALOG:
      return {
        ...state,
        dialog: false,
        dialogData: null,
      };
    case ADD_RECHARGE_REWARD:
      console.log("Adding Recharge Reward:", action.payload);
      return {
        ...state,
        rechargeRewards: state.rechargeRewards.map((level) => {
          if (level._id === action.payload._id) return action.payload;
          else return level;
        }),
      };
    case DELETE_RECHARGE_REWARD:
      return {
        ...state,
        rechargeRewards: state.rechargeRewards.map((level) => {
          if (level._id === action.payload._id) return action.payload;
          else return level;
        }),
      };
    default:
      return state;
  }
};

export default rechargeRewardReducer;
